import React, { Fragment, useState } from "react";
import Breadcrumbs from "../../CommonElements/Breadcrumbs";
import RealokasiContain from "../../Component/Realokasi/containers/RealokasiContain";
import { Card, CardBody, CardHeader, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import PageContainer from "../../Layout/Containers/PageContainer";
import StatusWidget from "../../Layout/Components/StatusWidget";
import { STATUS_DATA_TYPE } from "../../Constant/StatusData";

const Realokasi = () => {
  return (
    <PageContainer
      breadcrumbs={<Breadcrumbs parent="Realokasi" title="Realokasi" />}
    >
      {/* <Row xs="4">
              <Col className="text-center w-100">
                <Button
                  className="rounded"
                  color="primary"
                  onClick={() => setSelectedComponent((prev) => (prev = 1))}
                >
                  Daftar Realokasi
                </Button>
                <Button
                  className="rounded"
                  color="primary"
                  onClick={() => setSelectedComponent((prev) => (prev = 2))}
                >
                  Group Realokasi
                </Button>
              </Col>
            </Row> */}

      <RealokasiContain />
    </PageContainer>
  );
};

export default Realokasi;
